/**
 * eventqrcode.js
 * import axios for server calls
 * import Form is used for form fields and styling
 * import Button is the button field from react bootstrap
 * import Row and Col from react bootstrap for organizing display
 * import ErrorMessage for displaying error messages
 * import SuccMessage for displaying succ messages
 * import ChangeTime for converting time form 24 to 12 hour
 */
import React, {useState} from 'react'
import '../../style/qrcodeStyle.css';
import { useParams } from 'react-router-dom';
import Moment from 'moment'
import axios from 'axios';
import ChangeTime from '../Misc/changeTime';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import ErrorMessage from '../Misc/ErrorMessage';
import SuccMessage from '../Misc/succMessage';


function EventQrCode() {
    const {title} = useParams();
    const {time} = useParams();
    const {date} = useParams();
    const {location} = useParams();
    const {id} = useParams();
    //var twelve = require('twentyfour-to-twelve');
    const dateNew = Moment(date).format('MM-DD-YYYY');
    const [errorMessage, setErrorMessage] = useState(null);
    const [succMessage, setSuccMessage] = useState(null);

    /**
     * function addContact()
     * adds a contact to an event based on event id
     */
    async function addContact(e) {
        e.preventDefault();
        const email = e.target.email.value;
        const name = e.target.name.value;

        const eventId = {
            eventId: id,
            name: name,
            email: email
        }


        try {
            const response = await axios.post("https://link2rsvp.herokuapp.com/contact/qrcode", eventId)
            setSuccMessage(response.data.succMessage);
        } catch (err) {
            if (err.response) {
                if(err.response.data.errorMessage) {
                    setErrorMessage(err.response.data.errorMessage);
                }
            }
        }
        document.getElementById('email').value="";
        document.getElementById('name').value="";
    }

    return (
        <div>
        <div id="head">
            <h1 id="headp">LINK2RSVP</h1>
        </div>

        {
            succMessage && (
                <SuccMessage
                message={succMessage}
                clear={() => setSuccMessage(null)}
                />
            )
        }

        {
            errorMessage && (
                <ErrorMessage
                message={errorMessage} 
                clear={() => setErrorMessage(null)}
                />
            )
        }
        
        <div id="rsvp">
            <h2>Event Details</h2>
            <h4>{title}</h4>
            <p>Time: {ChangeTime(time)}</p>
            <p>Date: {dateNew}</p>
            <p>Location: {location}</p>
            <div id="info-p" style={{bordertop:"1px solid gray"}}>
              <p>If you would like to rsvp, Please fill out the form and
                  we will email you a link to RSVP to {title}</p>  
            </div>
            <div>
                <Form onSubmit={addContact} id="qr-form" style={{textAlign:"left"}}>
                    <Form.Group className="mb-3">
                        <label htmlFor="email">Name:</label>
                        <Form.Control
                            id="name"
                            type="text"
                            name="name"
                            placeholder="Enter your Name"
                            required
                            />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <label htmlFor="email">Email:</label>
                        <Form.Control
                            id="email"
                            type="eamil"
                            name="email"
                            placeholder="Enter Email"
                            required
                            />
                    </Form.Group>
                    <Button type="submit" id="qr-btn" variant="secondary" style={{backgroundColor: "#890E32"}}>submit</Button>
                </Form>
            </div>
        </div>
        </div>
    )
}

export default EventQrCode;